module.exports = __webpack_public_path__ + "img/big3-2.e68fd382.jpg";